export const texts = {
  NAMESPACE: 'Wix_Ads',
  MAIN_TEXT_KEY: 'Wix_Ads_2_top_banner_hover_1',
  MAIN_TEXT_DEFAULT: 'Upgrade your website to remove Wix ads',
  BUTTON_TEXT_KEY: 'Wix_Ads_2_top_banner_hover_CTA',
  BUTTON_TEXT_DEFAULT: 'Upgrade Now',
} as const;
